import React from 'react';

export const InboxCounterBadge: React.FC<{ count: number }> = ({ count }) => {
	return (
		<span className="rounded-[4px] p-1 size-6 flex items-center justify-center bg-[#8039DF1F] text-xs text-primary font-bold shrink-0">
			{count}
		</span>
	);
};
